export const setItemStorage = function (key: string, value: string | object | number) {
	window.sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
};

export const getItemStorage = function (key: string): any {
    const item = window.sessionStorage[key];
    return item ? JSON.parse(item) : null;
};

export const removeItemStorage = function (key: string) {
	return window.sessionStorage.removeItem(key);
};

